import { Button, Checkbox } from '@acpaas-ui/react-components';
import _ from 'lodash';
import { useState } from 'react';
import { useTableResource } from '../../hooks/useTableResource.hook';
import { OFFERING_THEMES_HOMEPAGE_RESOURCE } from '../../resources/offering.themes.homepage.resource';
import LinkButton from '../core/LinkButton';
import TextField from '../forms/TextField';
import { INPUT_STATES } from '../forms/forms.utils';
import OfferingsTitle from './OfferingsTitle';
import OfferintsFilterThemasSkeleton from './OfferintsFilterThemasSkeleton';

const MAX_THEMES_SHOWN_INITIALLY = 6;

const OfferingsFilter = ({ search = '', themes = [], onSearchChange, onSearchSubmit, onThemeChange, isLoading }) => {
  const [showAll, setShowAll] = useState(false);
  const { isLoading: isLoadingThemes, data } = useTableResource(OFFERING_THEMES_HOMEPAGE_RESOURCE, { isFetched: true });

  const handleShowAll = () => {
    setShowAll(true);
  };

  const handleFilterEnter = (event) => {
    if (event?.code === 'Enter') {
      onSearchSubmit();
    }
  };

  return (
    <div className="spo-o-offerings-filter">
      <OfferingsTitle>Filter</OfferingsTitle>
      <div className="spo-o-offerings-filter__input">
        <TextField
          value={search}
          onChange={onSearchChange}
          onKeyDown={handleFilterEnter}
          state={INPUT_STATES.DEFAULT}
          size="small"
          placeholder="Wat zoek je?"
          disabled={isLoading}
        />
        <Button icon="ai-search" outline size="small" onClick={onSearchSubmit} />
      </div>
      <div className="spo-o-offerings-filter__themes u-margin-top-md">
        <h4 className="u-text-primary u-margin-bottom-sm">
          <span className="spo-o-offerings-filter__themes-title">Labels</span>
          {/* <Icon name="ai-arrow-down-1" /> */}
        </h4>
        <ul className="a-list a-list--unstyled">
          {isLoadingThemes ? (
            <>
              <OfferintsFilterThemasSkeleton />
            </>
          ) : (
            <>
              <li>
                <Checkbox
                  label={`Alle`}
                  checked={themes.length === 0}
                  disabled={isLoading}
                  onChange={() => onThemeChange('')}
                />
              </li>
              {_.sortBy(data, (t) => t.name)
                .slice(0, showAll ? undefined : MAX_THEMES_SHOWN_INITIALLY)
                ?.map((theme, index) => (
                  <li key={`${theme.name}_${index}`}>
                    <Checkbox
                      disabled={isLoading}
                      label={`${theme.name}`}
                      checked={themes.includes(theme.name)}
                      onChange={() => onThemeChange(theme.name)}
                    />
                  </li>
                ))}
            </>
          )}
        </ul>
        {!isLoadingThemes && !showAll && data.length > MAX_THEMES_SHOWN_INITIALLY && (
          <LinkButton onClick={handleShowAll} disabled={isLoading}>
            Toon alles
          </LinkButton>
        )}
      </div>
    </div>
  );
};

export default OfferingsFilter;
